
(function(){
  'use strict';
  function init(){
    var p=document.querySelector('.luxe-preloader,.arshe-preloader,[data-arshe-preloader]');
    if(!p || p.dataset.v18Exit==='1') return;

    /* Remove tagline/decorations that may still exist in older markup. */
    p.querySelectorAll('.preloader-tagline,.arshe-preloader__tagline,[class*="tagline"],.star,.dot,[class*="star"],[class*="dot"],[class*="glow"]')
      .forEach(function(el){el.remove();});

    /* No movement: only opacity changes. */
    p.style.background='#fff';
    p.style.backgroundImage='none';
    p.style.transform='none';
    p.style.opacity='1';
    p.style.visibility='visible';
    p.style.transition='opacity 850ms cubic-bezier(.22,1,.36,1)';

    window.setTimeout(function(){
      if(p.dataset.v18Exit==='1') return;
      p.dataset.v18Exit='1';
      p.style.transition='opacity 900ms cubic-bezier(.22,1,.36,1)';
      p.style.opacity='0';

      window.setTimeout(function(){
        p.style.visibility='hidden';
        p.style.pointerEvents='none';
        if(p.parentNode) p.parentNode.removeChild(p);
      },950);
    },1250);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
